export default {
	arzte_und_apotheker_bank: 'Ärzte- und Apothekerbank',
	austrian_anadi_bank_ag: 'Austrian Anadi Bank AG',
	bank_austria: 'Bank Austria',
	bankhaus_carl_spangler: 'Bankhaus Carl Spängler &amp; Co.AG',
	bankhaus_schelhammer_und_schattera_ag:
		'Bankhaus Schelhammer &amp; Schattera AG',
	bawag_psk_ag: 'BAWAG P.S.K. AG',
	bks_bank_ag: 'BKS Bank AG',
	brull_kallmus_bank_ag: 'Brüll Kallmus Bank AG',
	btv_vier_lander_bank: 'BTV VIER LÄNDER BANK',
	capital_bank_grawe_gruppe_ag: 'Capital Bank Grawe Gruppe AG',
	dolomitenbank: 'Dolomitenbank',
	easybank_ag: 'Easybank AG',
	erste_bank_und_sparkassen: 'Erste Bank und Sparkassen',
	hypo_alpeadriabank_international_ag:
		'Hypo Alpe-Adria-Bank International AG',
	hypo_noe_lb_fur_niederosterreich_u_wien:
		'HYPO NOE LB für Niederösterreich u. Wien',
	hypo_oberosterreich_salzburg_steiermark:
		'HYPO Oberösterreich,Salzburg,Steiermark',
	hypo_tirol_bank_ag: 'Hypo Tirol Bank AG',
	hypo_vorarlberg_bank_ag: 'Hypo Vorarlberg Bank AG',
	hypo_bank_burgenland_aktiengesellschaft:
		'HYPO-BANK BURGENLAND Aktiengesellschaft',
	marchfelder_bank: 'Marchfelder Bank',
	oberbank_ag: 'Oberbank AG',
	raiffeisen_bankengruppe_osterreich: 'Raiffeisen Bankengruppe Österreich',
	schoellerbank_ag: 'Schoellerbank AG',
	sparda_bank_wien: 'Sparda-Bank Wien',
	volksbank_gruppe: 'Volksbank Gruppe',
	volkskreditbank_ag: 'Volkskreditbank AG',
	vr_bank_braunau: 'VR-Bank Braunau',
};
